module.exports = __webpack_public_path__ + "static/media/ic_marketing_inactive.557ea835.svg";